import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

const InvoiceMenuButton = ({ viewUrl, payUrl, isSubscription }) => (
  <UncontrolledDropdown>
    <DropdownToggle caret>
      {isSubscription ? 'Last Invoice' : 'Invoice'}
    </DropdownToggle>
    <DropdownMenu>
      <a href={payUrl} className="dropdown-item">Pay</a>
      <a href={viewUrl} className="dropdown-item">View</a>
    </DropdownMenu>
  </UncontrolledDropdown>
);

InvoiceMenuButton.propTypes = {
  viewUrl: PropTypes.string.isRequired,
  payUrl: PropTypes.string.isRequired,
  isSubscription: PropTypes.bool.isRequired,
};

export default InvoiceMenuButton;



// WEBPACK FOOTER //
// app/client/bundles/PageSpecificComponents/InvoiceMenuButton.jsx